import { ApiService } from "./api.service";
import type { TUserWorkHours, TWeekdayKey } from "@/types/user";

const WEEKDAY_KEYS: TWeekdayKey[] = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

export function normalizeWorkHours(raw: Record<string, unknown>): TUserWorkHours {
  const out: Record<string, unknown> = { ...raw };
  if (typeof raw.capacity_percent === "string") {
    out.capacity_percent = Number.parseFloat(raw.capacity_percent);
  }
  for (const day of WEEKDAY_KEYS) {
    const value = raw[day];
    if (typeof value === "string") out[day] = Number.parseFloat(value);
  }
  for (const key of ["work_start_time", "work_end_time"] as const) {
    const value = raw[key];
    if (typeof value === "string") out[key] = value.slice(0, 5);
  }
  return out as unknown as TUserWorkHours;
}

export class WorkHoursService extends ApiService {
  async getCurrentUserWorkHours(): Promise<TUserWorkHours> {
    const raw = await this.get<Record<string, unknown>>("/api/users/me/work-hours/");
    return normalizeWorkHours(raw);
  }

  async updateCurrentUserWorkHours(data: Partial<TUserWorkHours>): Promise<TUserWorkHours> {
    const raw = await this.patch<Record<string, unknown>>("/api/users/me/work-hours/", data);
    return normalizeWorkHours(raw);
  }
}
